import { render } from "./FadeDown.vue?vue&type=template&id=1a456ce2&scoped=true&ts=true"
import script from "./FadeDown.vue?vue&type=script&lang=ts"
export * from "./FadeDown.vue?vue&type=script&lang=ts"

import "./FadeDown.vue?vue&type=style&index=0&id=1a456ce2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a456ce2"]])

export default __exports__